import {collection, documentId, query, where, QueryConstraint} from "firebase/firestore";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {useMemo} from "react";
import {appFirestore} from "../../../index";
import {fuelInvoiceConverter} from "./fuelInvoiceConverter";
import {RRFuelInvoiceType} from "../../types/RRFuelInvoiceType";

interface UseFuelInvoicesProps {
    invoiceId?: string;
    invNumber?: string;
    periodFrom?: Date;
    periodTo?: Date;
    driverId?: string;
    truckId?: string;
}
export const useFuelInvoices = (props: UseFuelInvoicesProps) => {
    const {invoiceId, invNumber, periodFrom, periodTo, driverId, truckId} = props;

    const invoicesCollectionRef = useMemo(
        () => collection(appFirestore, "fuelInvoices").withConverter<RRFuelInvoiceType>(fuelInvoiceConverter),
        []
    );
    const queryConstraints = useMemo<QueryConstraint[]>(() => {
        const next: QueryConstraint[] = [];
        if (invoiceId) {
            next.push(where(documentId(), "==", invoiceId));
        }
        if (invNumber) {
            next.push(where("invNumber", "==", invNumber));
        }
        if (periodFrom) {
            next.push(where("invDate", ">=", periodFrom));
        }
        if (periodTo) {
            next.push(where("invDate", "<=", periodTo));
        }
        if (driverId) {
            next.push(where("driverId", "==", driverId));
        }
        if (truckId) {
            next.push(where("truckId", "==", truckId));
        }
        return next;
    }, [invoiceId, invNumber, periodFrom, periodTo, driverId, truckId]);
    const invoicesQuery = useMemo(
        () => (queryConstraints.length ? query(invoicesCollectionRef, ...queryConstraints) : invoicesCollectionRef),
        [invoicesCollectionRef, queryConstraints]
    );
    const [invoices, loading, error] = useCollectionData<RRFuelInvoiceType>(invoicesQuery);

    return {invoices: invoices ?? [], loading, error};
};
